import React from "react";
import {
  useTooltipState,
  Tooltip as ReakitTooltip,
  TooltipReference,
  TooltipArrow,
} from "reakit/Tooltip";
import styles from "./Tooltip.module.css";
import cx from "classnames";

type Variant = "LIGHT" | "DARK";

/**
 * Component for displaying tooltip to the user
 *
 * @example
 *  <Tooltip title="Więcej informacji">
 *    <IconButton icon="moreInfo"/> (any component)
 *  </Tooltip>
 *
 * @example
 *  <Tooltip title="Sygnatura zamówienia">
 *     <Typography>{order.signature}</Typography>
 *  </Tooltip>
 */
export const Tooltip = ({
  title,
  children,
  variant = "LIGHT",
}: {
  title: string;
  children: JSX.Element;
  variant?: Variant;
}) => {
  const tooltip = useTooltipState({ unstable_timeout: 400 });
  return (
    <>
      <TooltipReference {...tooltip} {...children.props}>
        {referenceProps => React.cloneElement(children, referenceProps)}
      </TooltipReference>
      {Boolean(title) && (
        <ReakitTooltip
          {...tooltip}
          className={cx(styles.tooltip, {
            [styles.light]: variant === "LIGHT",
            [styles.dark]: variant === "DARK",
          })}
        >
          <TooltipArrow {...tooltip} size="20px" />
          {title}
        </ReakitTooltip>
      )}
    </>
  );
};
